document.addEventListener('turbo:load', function () {
  if (location.pathname.match(/^\/properties\/\d+/)) {
    PropertyProfile.observeActiveSyncs();
  }

  const backButton = document.querySelector('.fa-angle-double-left');

  if (backButton) {
    backButton.addEventListener('click', (event) => {
      event.preventDefault();
      history.back();
    });
  }
});

const PropertyProfile = (function () {
  // Timeout
  const timeout = 4_000;

  // Active Sync row
  const activeSyncRowSelector = 'tr[data-active-sync-url]';
  const durationColumnSelector = 'td.duration';
  const statusColumnSelector = 'td.sync-completed';
  const errorColumnSelector = 'td.error-explanation';
  const syncSuccessIcon = '<i class="fa fa-check-circle active"></i>';
  const syncFailedIcon = '<i class="fa fa-times-circle failed"></i>';

  // Start Sync Button
  const syncButtonSelector = '#sync-button';
  const startSyncIcon = '<i class="fas fa-redo-alt"></i>';

  // Health Bar
  const activeSyncHealthBarElementSelector = '.health-bar i:last-child';
  const syncSuccessIconClassName = 'fa fa-check-circle active';

  // Variables
  let activeSyncChecksCount = 0; // Increases by 1 after each check;
  let activeSyncRow;
  let activeSyncUrl;

  function observeActiveSyncs() {
    activeSyncRow = document.querySelector(activeSyncRowSelector);
    if (activeSyncRow) {
      activeSyncUrl = activeSyncRow.dataset.activeSyncUrl;
      setTimeout(fetchLastSyncStatus, timeout);
    }
  }

  function fetchLastSyncStatus() {
    activeSyncChecksCount += 1;
    fetch(activeSyncUrl)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(
            `Error loading active sync data. ${response.status} ${response.statusText}`
          );
        }
      })
      .then((data) => {
        if (data.checkpoint == 6) {
          markSyncAsSuccess(data);
        } else if (data.is_running) {
          setTimeout(fetchLastSyncStatus, timeout * activeSyncChecksCount);
        } else {
          markSyncAsFailed(data);
        }
      })
      .catch((error) => console.error(error));
  }

  function markSyncAsSuccess(updates) {
    updateActiveSyncRow(updates.mins_duration, syncSuccessIcon, null);
    markSyncAsSuccessInHealthBar();
    enableSyncButton();
  }

  function markSyncAsFailed(updates) {
    updateActiveSyncRow(updates.mins_duration, syncFailedIcon, updates.error_explanation);
    markSyncAsFailedInHealthBar();
    enableSyncButton();
  }

  function updateActiveSyncRow(duration, icon, error) {
    activeSyncRow.querySelector(durationColumnSelector).innerHTML = duration;
    activeSyncRow.querySelector(statusColumnSelector).innerHTML = icon;
    if (error) {
      activeSyncRow.querySelector(errorColumnSelector).innerHTML = error;
    }
  }

  function enableSyncButton() {
    let syncButton = document.querySelector(syncButtonSelector);
    syncButton.innerHTML = startSyncIcon;
    syncButton.disabled = false;
  }

  function markSyncAsSuccessInHealthBar() {
    document.querySelector(activeSyncHealthBarElementSelector).className = syncSuccessIconClassName;
  }

  function markSyncAsFailedInHealthBar() {
    document.querySelector(activeSyncHealthBarElementSelector).className =
      'fa fa-times-circle failed';
  }

  return { observeActiveSyncs: observeActiveSyncs };
})();
